import styled from 'styled-components'

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;

  .depositar-feedback-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  .feedback-column {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 30px;
    font-weight: 400;
    font-size: 24px;
    text-align: center;
    color: #00cd52;
  }

  .feedback-icon {
    filter: brightness(0) saturate(100%) invert(49%) sepia(93%) saturate(696%)
      hue-rotate(101deg) brightness(97%) contrast(101%);
    height: 64px;
    width: 64px;
  }

  .depositar-title {
    color: var(--Preto-Principal, #1c1d22);
    font-family: Inter;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .depositar-title span {
    font-weight: 700;
  }

  .depositar-cards-container {
    display: flex;

    margin: 32px 1px;

    gap: 16px;
  }

  .depositar-form-container {
    display: flex;
    gap: 14px;
    margin-top: 32px;
  }

  .depositar-container {
    display: flex;
    flex-direction: column;

    gap: 40px;
  }

  .depositar-form-container {
    display: flex;
    gap: 14px;
  }

  .depositar-table-container {
    display: flex;
    flex-direction: column;

    border-top: 0.5px solid #eee;
    padding-top: 40px;

    gap: 32px;
  }

  .depositar-table-title {
    color: #000;

    font-family: 'Inter';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }

  .depositar-depositing {
    width: 100%;
    color: var(--Preto-Principal, #1c1d22);
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: 'Inter';
    font-size: 13px;
    font-style: normal;
    font-weight: 300;
    line-height: 32px; /* 200% */
  }

  .depositar-pix-info-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-bottom: 40px;
    width: 100%;
  }

  .depositar-valor {
    color: #00cd52;
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: 'Inter';
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 32px;

    margin-right: 10px;
  }

  .depositar-text {
    color: var(--Preto-Principal, #1c1d22);
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: 'Inter';
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 32px;
  }

  .depositar-text1 {
    color: var(--Preto-Principal, #1c1d22);
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: 'Inter';
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px; /* 175% */

    margin-right: 5px;
  }

  .depositar-text2 {
    color: var(--Preto-Principal, #1c1d22);
    font-feature-settings: 'clig' off, 'liga' off;
    font-family: 'Inter';
    font-size: 13px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;

    margin-right: 5px;
  }

  .depositar-container-info {
    width: 100%;
    margin-bottom: 16px;

    /* display: flex; */
  }

  .depositar-codigoPix {
    width: 315px;
    // height: auto;
    padding: 5px 18.5px;
    border-radius: 5px;
    background: var(--Branco-Surface-FD, #fdfdfd);
    box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.25);
    white-space: normal;
    word-wrap: break-word;
    text-align: center;
    font-size: 12px;
    margin-bottom: 16px;
    // overflow: hidden;
    // text-overflow: ellipsis;
  }

  .depositar-qrcode-container {
    /* display: flex; */

    gap: 80px;
  }

  .depositar-qrcode {
    width: 200px;
    height: 200px;
    padding: 10px;
    margin: 10px;
    box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.25);
    background: var(--Branco-Surface-FD, #fdfdfd);
  }

  .depositar-codigo-container {
    width: 315px;
    margin-top: 5px;
    display: flex;
    flex-direction: column;

    gap: 32px;
  }
`
